module.exports = __webpack_public_path__ + "static/media/contact2.8d8f190a.gif";